import React from 'react';
import PropTypes from 'prop-types';
import { FDLozenge, FDStack } from '@facet-wealth/design';
import { LabelTextMedium } from 'Packages/FacetDesign/Components';

const SACStepWithOptionalLozenge = ({ stepResource }) => {
  const active = stepResource.attr('isActive') === 'true';

  return (
    <FDStack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'space-between'}>
      <LabelTextMedium
        color={active ? 'textPrimary' : 'textDisabled'}
        value={stepResource.attr('label')}
      />
      {stepResource.attr('description') && (
        <FDLozenge
          color={active ? 'info' : 'subtle'}
          label={stepResource.attr('description')}
          size={'lg'}
        />
      )}
    </FDStack>
  );
};

SACStepWithOptionalLozenge.propTypes = {
  stepResource: PropTypes.object.isRequired,
};

export default SACStepWithOptionalLozenge;
